import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { FloatingTooltip } from '../Floating'
import { Rating, RATING_ITEM_SIZE } from '../Rating'

import {
  ENTITY_EXTRA_TAGS_RATING_AVG,
  EntityExtraTagsRequestRules,
} from './EntityExtraTags.constants'
import {
  getEntityExtraTagsItem,
  getTags,
  hasEntityExtraTags,
} from './EntityExtraTags.utils'
import { getEntityExtraTagsClickHandler } from './EntityExtraTags.utils.click'

import * as styles from './EntityExtraTags.module.css'

function EntityExtraTags({
  className = styles.EntityExtraTags,
  directoryId,
  extra,
  id,
  interactable,
  objectId,
  rules = EntityExtraTagsRequestRules,
  onClickDocFlowTag,
  onClickEmailTag,
  onClickFileTag,
  onClickRequestTag,
}) {
  const { t } = useTranslation()

  const item = getEntityExtraTagsItem({ extra, id })

  const tagList = getTags({ item, rules, t })

  return hasEntityExtraTags({ item, tagList }) ? (
    <div className={className}>
      {tagList.map(tag => (
        <tag.Tag
          {...tag}
          {...(interactable ? null : { tooltip: null })}
          className={classNames(styles.tag, {
            [styles.noInteractable]: !interactable,
          })}
          key={tag.qaName}
          onClick={
            interactable
              ? getEntityExtraTagsClickHandler({
                  directoryId,
                  handlers: {
                    onClickDocFlowTag,
                    onClickEmailTag,
                    onClickFileTag,
                    onClickRequestTag,
                  },
                  itemId: id,
                  objectId,
                  tagId: tag.qaName,
                })
              : undefined
          }
        />
      ))}

      {!!item?.[ENTITY_EXTRA_TAGS_RATING_AVG] && (
        <FloatingTooltip
          content={
            interactable
              ? t('RequestTable.IconRatingTooltipKey', {
                  rating: item[ENTITY_EXTRA_TAGS_RATING_AVG],
                })
              : null
          }
        >
          <div>
            <Rating
              interactable={interactable}
              itemSize={RATING_ITEM_SIZE.size24}
              rating={item[ENTITY_EXTRA_TAGS_RATING_AVG]}
            />
          </div>
        </FloatingTooltip>
      )}
    </div>
  ) : null
}

export default EntityExtraTags
